import React, { useEffect, useState } from "react";
import "./GasPricing.css";
import { Link, NavLink } from "react-router-dom";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Pagination, Stack, Typography } from "@mui/material";
// import ViewAdminVehicle from "../../../components/Modal/ViewAdminVehicle";
import Loader from "../../../components/Utilities/Loader/Loader";
import { toast } from "react-toastify";
import EditGasPrice from "../../../components/Modal/Admin/GasPricing/EditGasPrice";
import CreateGasprice  from "../../../components/Modal/Admin/GasPricing/CreateGasPrice";
import ViewGasPrice from "../../../components/Modal/Admin/GasPricing/ViewGasPrice";
import axiosInstanceAdmin from "../../../hooks/axiosInstanceAdmin";

export default function Gaspricing() {
  const [gaspricing, setGaspricing] = useState([]);
  const [filter, setFilter] = useState("");
  const [show, setShow] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [ShowView, setShowView] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [loading, setLoading] = useState(false);
  const [currentGaspricing, setCurrentGaspricing] = useState(null);
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);

  //  state for pagination
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [pageCount, setPageCount] = useState(1);

  //  pagination function
  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const handleShow = () => setShow(true);

  const handleShowEdit = (data) => {
    setCurrentGaspricing(data);
    setShowEdit(true);
  };

  const handleShowView = (data) => {
    setCurrentGaspricing(data);
    setShowView(true);
  };

  const handleClose = () => {
    setShow(false);

    setShowEdit(false);
    setShowView(false);
  };
  const handleRefresh = () => {
    setRefreshKey((prevRefreshKey) => prevRefreshKey + 1);
  };

  const handleFilterChange = (event) => {
    setFilter(event.target.value);
  };

  const handleDeleteOpen = async (data) => {
    await setCurrentGaspricing(data);
    await setDeleteOpen(true);
  };

  const handleDeleteClose = () => {
    setDeleteOpen(false);
  };

  const fetchGasPricing = () => {
    setLoading(true);
    axiosInstanceAdmin
      .get(
        `admin/gas-pricings?page=${page}&limit=${perPage}&filter=${filter}`
      )
      .then((response) => {
        setGaspricing(response.data.data.items);
      })
      .catch((err) => {
        toast.error("An error occured. Please, try again");
      })
      .finally(() => setLoading(false));
  };

  const handleDelete = () => {
    setLoading(true);
    axiosInstanceAdmin
      .delete(
        `admin/gas-pricings/${currentGaspricing?.id}`
      )
      .then((response) => {
        toast.success("Gas Pricing deleted successfully")
        setDeleteOpen(false)
        handleRefresh()
      })
      .catch((err) => {
        toast.error("An error occured. Please, try again");
      })
      .finally(() => setLoading(false));
  };

  // const filterVehicle = () => {
  //   fetchVehicles();
  // };

  useEffect(() => {
    fetchGasPricing();
  }, [page, perPage, refreshKey]);


  return (
    <>
      <div className="pagetitle">
        <h1>Gas Pricing</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <NavLink to="/app/dashboard">Dashboard</NavLink>
            </li>
            <li className="breadcrumb-item active">Gas Pricing</li>
          </ol>
        </nav>
      </div>

      <section className="section vehicle">
        <div className="row">
          <div className="col-lg-12 col-md-12 order-2 order-sm-1 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <div className="d-flex justify-content-between">
                  <div>
                    <h4 className="card-title d-flex align-items-center">
                      Gas Pricing
                    </h4>
                  </div>
                  {/* <div>
                    <button
                      className="vehicle-button mt-3 btn btn-primary"
                      onClick={handleShow}
                    >
                      <i className="mdi mdi-plus-circle-outline"></i> New
                      Gas Pricing
                    </button>
                  </div> */}
                </div>

                {/* Filter input */}
                {/* <div className="row mb-3">
                  <div className="col-lg-3">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search..."
                        value={filter}
                        onChange={handleFilterChange}
                      />
                      <button
                        onClick={filterVehicle}
                        className="btn btn-primary"
                        type="submit"
                      >
                        Go
                      </button>
                    </div>
                  </div>
                </div> */}

                {gaspricing && gaspricing.length > 0 ? (
                  <>
                    {/* <!-- Start Table --> */}
                    <div className="scroll-area-lg">
                      <div className="table-responsive-sm">
                        <table className="table table-striped table-borderless table-hover ">
                          <thead>
                            <tr>
                              <th scope="col">#</th>
                              <th scope="col">Quantity (kg)</th>
                              <th scope="col">Price(₦)</th>
                              <th scope="col">Discount (%)</th>
                              <th scope="col">Status</th>
                              <th scope="col" width="5%"></th>
                            </tr>
                          </thead>
                          <tbody>
                            {gaspricing.map((gas_price, i) => (
                              <tr key={gas_price.id}>
                                <th scope="row">{i + 1}</th>
                                <td>1</td>
                                <td>{ Number(gas_price.price).toLocaleString()}</td>
                                <td>{gas_price.discount}</td>
                                <td>
                                  <span
                                    className={`badge text-capitalize ${
                                      gas_price.status == "active"
                                        ? "bg-success"
                                        : "bg-danger"
                                    }`}
                                  >
                                    {gas_price.status}
                                  </span>
                                </td>
                                <td className="dropdown">
                                  <Link
                                    className="dropdown-toggle menu"
                                    id={`actionDropdown_${gas_price.id}`}
                                    href="#"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    <i className="mdi mdi-apps"></i>
                                  </Link>
                                  <div
                                    className="dropdown-menu dropdown-menu-right preview-list"
                                    aria-labelledby={`actionDropdown_${gas_price.id}`}
                                  >
                                    <Link
                                      className="dropdown-item custom-drop"
                                      onClick={() => handleShowEdit(gas_price)}
                                    >
                                      <i className="mdi mdi-pencil mr-2 text-success"></i>{" "}
                                      <span>Edit Gas Pricing</span>
                                    </Link>
                                    {/* <div className="dropdown-divider"></div> */}
                                   
                                    {/* <div className="dropdown-divider"></div> */}
                                    {/* <Link
                                      className="dropdown-item custom-drop"
                                      onClick={() => handleShowView(gas_price)}
                                    >
                                      <i className="mdi mdi-clock mr-2 text-warning"></i>{" "}
                                      <span>View Gas Pricing</span>
                                    </Link> */}
                                    {/* <div className="dropdown-divider"></div>
                                    <Link className="dropdown-item custom-drop" onClick={() => handleDeleteOpen(gas_price)}>
                                      <i className="bi bi-trash-fill text-danger"></i>{" "}
                                      <span>Delete</span>
                                    </Link> */}
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    {/* <!-- End Table --> */}
                  </>
                ) : (
                  <div className="alert alert-info mt-4">No record found</div>
                )}
              </div>
            </div>
          </div>
        </div>

        <CreateGasprice 
          show={show}
          closeModal={handleClose}
          refreshPage={handleRefresh}
        />

        {currentGaspricing && <EditGasPrice
          show={showEdit}
          closeModal={handleClose}
          refreshPage={handleRefresh}
          currentGasPrice={currentGaspricing}
        />}

        {currentGaspricing && <ViewGasPrice
          show={ShowView}
          closeModal={handleClose}
          refreshPage={handleRefresh}
          currentGasPrice={currentGaspricing}
        />}

      

      

        {/* Delete Dialog */}
        {currentGaspricing && (
          <>
            <Dialog
              open={deleteOpen}
              onClose={handleDeleteClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
              Delete <b className="text-primary">Gas Pricing</b>{" "}
                {/* Delete <b className="text-primary">{currentGaspricing.brand_name} {currentGaspricing.model}</b>{" "} */}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Are you sure you want to perform this operation?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button className="text-danger" onClick={handleDeleteClose}>
                  Cancel
                </Button>
                <Button onClick={handleDelete} autoFocus>
                  Continue
                </Button>
              </DialogActions>
              {isDeleteLoading && <Loader />}
            </Dialog>
          </>
        )}

        {loading && <Loader />}
      </section>
    </>
  );
}
